


























import { Component, Vue } from 'vue-property-decorator';
import { CheckoutStep } from '@/store/models';
import checkout from '@/store/modules/checkout';
import user from '@/store/modules/user';
import cart from '@/store/modules/cart';

@Component({})
export default class Steps extends Vue {
    private stepCount = 0;

    get steps(): CheckoutStep[] {
        return checkout.steps;
    }

    private hasSteps() {
        const currentStep = this.$route.params.step;

        switch (currentStep) {
            case 'login':
                return false;
            case 'shipping':
                this.stepCount = 1;
                return true;
            case 'invoice':
                this.stepCount = checkout.confirmStep ? 3 : 2;
                return true;
            default:
                return false;
        }
    }

    private changeStep(step: string) {
        if (this.isClickable(step) && step !== 'login') {
            this.$router.push({ path: `/checkout/${step}` });

            if (step === 'invoice') {
                checkout.setConfirmStep(false);
                checkout.flagStep({ flag: false, type: 'u', stepName: 'confirm' });
                checkout.flagStep({ flag: false, type: 'a', stepName: 'confirm' });
                checkout.flagStep({ flag: true, type: 'a', stepName: 'invoice' });
            }
        }
    }

    private isClickable(step: string): boolean {
        const currentStep = this.$route.params.step;

        if (step === 'user' && user.isLoggedin) {
            return false;
        }

        if (step === 'order') {
            return false;
        }

        if (currentStep === 'order') {
            return false;
        }

        if (step === 'shipping' && cart.isVirtual) {
            return false;
        }

        const stepObj: CheckoutStep = checkout.stepByName(step);

        return stepObj.unlocked && !stepObj.active;
    }
}
